<template>
  <v-content>
    <v-container class="py-12">
      <h2 class="display-1" data-testid="failed-heading">
        Submission failed
      </h2>

      <p class="mt-4">
        Your report submission was unsuccessful. Click here to
        <a v-bind:href=getCallReportingHomeURL>submit the report again</a>
        or tap close to return to the home page.
      </p>

      <div class="mt-12">
        <v-btn
          data-testid="btn-retry"
          :color="isMagenta ? 'primary' : 'warning'"
          type="submit"
          large
          width="150px"
          :style="{
            'border-radius': isMagenta ? 0 : undefined
          }"
          elevation="0"
          :href="isMagenta
            ? 'https://www.t-mobile.com/customers/scam-shield'
            : 'https://www.metrobyt-mobile.com/scam-shield'"
        >Close</v-btn>
      </div>
    </v-container>
  </v-content>
</template>

<script lang="ts">
import { Vue, Component, PropSync } from 'vue-property-decorator'

import config from '@/config'
import { CallDetailsInformation } from '@/types'
import { getCallReportingHomeURL } from '@/utils'

@Component
export default class Failed extends Vue {
  @PropSync('formStep')
  private step!: 'Details' | 'Review' | 'Confirmation' | 'Failed'

  @PropSync('callDetails')
  private data!: CallDetailsInformation

  private get isMagenta () {
    return config.isMagenta
  }

  private get getCallReportingHomeURL () {
    return getCallReportingHomeURL()
  }
}
</script>
